export default __webpack_public_path__ + "static/media/1083.788caf7a.jpeg";